export const FETCH_YARD_CONFIG_INITIALIZATION = "FETCH_YARD_CONFIG_INITIALIZATION";
export const FETCH_YARD_CONFIG_SUCCESS = "FETCH_YARD_CONFIG_SUCCESS";
export const FETCH_YARD_CONFIG_FAILURE = "FETCH_YARD_CONFIG_FAILURE";
export const CLEAR_YARD_CONFIG_DATA = "CLEAR_YARD_CONFIG_DATA";
